import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({
    endPoint: 'CampaignProcessFiles',
    method: 'GET',
    body: null,
    token: token
  })
}
